import { View } from 'react-native'
import { styled } from '~/utils'

export const Container = styled(View, theme => {
  return {
    base: {
      flexDirection: 'row',
      backgroundColor: 'transparent',
    },
    variants: {
      size: {
        tiny: {
          gap: theme.spacingInlineNone,
        },
        small: {
          gap: theme.spacingInlineOnepulse,
        },
      },
    },
  }
})
